export default __webpack_public_path__ + "static/media/boxImg.c8138e0c.png";